import { Box, Typography, useMediaQuery } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { useIsMobile, useL10n } from '@uplift/hooks';
import { Button, Modal, ModalContent } from '@uplift/ui-v2';
import { useEffect, useState } from 'react';
import { ReactComponent as Rotate } from './rotate.svg';

const useModalStyles = makeStyles({ name: 'better-in-portrait-modal' })(theme => ({
  contentRoot: {
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),
  },
  text: {
    fontSize: '14px',
    maxWidth: '167px',
    textAlign: 'center',
  }
}));


export const BetterInPortraitModal: React.VFC = () => {
  const l10n = useL10n();
  const { classes } = useModalStyles();
  const isMobile = useIsMobile();
  const isLandscape = useMediaQuery('(orientation: landscape)');
  const [ isOpen, setIsOpen ] = useState(isLandscape);

  useEffect(() => {
    if (!isMobile) {
      return;
    }

    setIsOpen(isLandscape);
  }, [ isLandscape, isMobile ]);

  const handleClose = () => {
    setIsOpen(false);
  };

  if (!isMobile) {
    return null;
  }

  return (
    <Modal open={isOpen} onClose={handleClose} disableBackdropClick disableEscapeKeyDown>
      <ModalContent>
        <Box className={classes.contentRoot}>
          <Rotate />
          <Typography className={classes.text}>
            {l10n.sessions.betterInPortraitModal.switch}
          </Typography>
          <Button variant="contained" color="secondary" onClick={handleClose}>
            {l10n.sessions.betterInPortraitModal.gotIt}
          </Button>
        </Box>
      </ModalContent>
    </Modal>
  );
};
